/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getComponentZoneLayout } from "cms/components/components/component";
import { FormsComponentDisplay } from "cms/components/components/forms/display";
import { FormsComponentEditor } from "cms/components/components/forms/edit";

const FormsComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <FormsComponentDisplay />,
        editComponent: <FormsComponentEditor />,
    };

    return getComponentZoneLayout(zoneProps);
};

FormsComponent.displayName = "FormsComponent";
export { FormsComponent };
